import { useCommunityVariant } from "@/src/common/components/product-demo/community-variant-context";

interface CommunityLogoProps {
	size?: number;
	rounded?: string;
	className?: string;
}

export function CommunityLogo({ size = 32, rounded = "rounded-lg", className = "" }: CommunityLogoProps) {
	const { palette } = useCommunityVariant();
	return (
		<span
			aria-hidden="true"
			className={`inline-flex shrink-0 items-center justify-center overflow-hidden ${rounded} ${className}`}
			style={{ width: size, height: size, background: palette.accent }}
		>
			<svg viewBox="0 0 40 40" className="h-full w-full" aria-hidden="true">
				<g fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round">
					<circle cx="20" cy="20" r="9" />
					<path d="M20 4v7M20 29v7M4 20h7M29 20h7M8.7 8.7l5 5M26.3 26.3l5 5M31.3 8.7l-5 5M13.7 26.3l-5 5" />
				</g>
				<circle cx="20" cy="20" r="3.5" fill="#fff" />
			</svg>
		</span>
	);
}
